module.exports = __webpack_public_path__ + "static/img/150017.afc11aba.png";